import React, { useState } from 'react'
import { StyledPaper, StyledTabs } from '../fui/FuiStyles'
import { Tab } from '@material-ui/core'
import LicenseManagement from './LicenseManagement'
// import SplunkLicenseConfig from './SplunkLicenseConfig'

export default function LicensePage() {
  const [tabIndex, setTabIndex] = useState(0)  

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue)
  }

  return (
    <div>
      <StyledTabs
        value={tabIndex}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
      >
        <Tab label="License Management" />
        {/* <Tab label="Splunk License Config" /> */}
      </StyledTabs>

      <StyledPaper style={{ height: "80%", overflow: "auto", marginTop: 16 }}>
        {tabIndex === 0 && <LicenseManagement />}
        {/* {tabIndex === false && <SplunkLicenseConfig />} */}
      </StyledPaper>
    </div>
  )
}
